export enum InsuranceType {
  EMPLOYER = 'Employer',
  MARKETPLACE = 'Marketplace',
  MEDICAID = 'Medicaid',
  MEDICARE = 'Medicare',
  UNKNOWN = 'Unknown',
  NO_INSURANCE = 'No Insurance'
}
